import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import config from "../../util/ApiforContext";
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import RequestHandler from "util/RequestHandler";
import { Table, Row, Col, Select, notification, Card, Button, Form, Modal, Input, Space, DatePicker, Tooltip } from "antd";
import { BarsOutlined, FormOutlined } from "@ant-design/icons";
import 'moment/locale/tr';
import { ColumnHelper, RowHelper } from "util/TableHelper";
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/tr_TR';
import CurrencyInput from 'react-currency-input';
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};
const CreateEArchive = (props) => {
  const errorList = [];
  const { Option } = Select;
  const history = useHistory();
  const [firmBranchNumber, setFirmBranchNumber] = useState();
  const [currencyDropdown, setcurrencyDropdown] = useState([]);
  const [firmDropdown, setFirmDropdown] = useState([]);
  const [inputAmountList, setInputAmountList] = useState([]);
  const [updateButtonVisible, setUpdateButtonVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [kdvPercentValue, setKdvPercentValue] = useState([]);
  const [inputStockCountList, setInputStockCountList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [taxPercent, setTaxPercent] = useState(0);
  const [vkn, setVkn] = useState("");
  const [eInvoiceCodeVisible, setEInvoiceCodeVisible] = useState(false);
  const [totalWithTax, setTotalWithTax] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [eArchiveType, setEArchiveType] = useState(1);
  const [sendEArchiveLoading, setSendEArchiveLoading] = useState(false);
  const [taxOffice, setTaxOffice] = useState("");
  const [dateChange, setDateChange] = useState(moment());
  const [kdvPercent, setKdvPercent] = useState("");
  const [eInvoiceList, setEInvoiceList] = useState([]);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [currencyChange, setCurrencyChange] = useState("TRY");
  const [senario, setSenario] = useState("EARSIVFATURA");
  const [eInvoiceCodeId, setEInvoiceCodeId] = useState("");
  const [type, setType] = useState("SATIS");
  const [firmId, setFirmId] = useState("");
  const [items, setItems] = useState(['jack', 'lucy']);
  const [name, setName] = useState('');
  const [tcNo, setTcNo] = useState();
  const [description, setDescription] = useState("");
  const [groupCode, setGroupCode] = useState();
  const [phone, setPhone] = useState();
  const [mobilPhone, setMobilPhone] = useState();
  const [fax, setFax] = useState();
  const [firmClassId, setFirmClassId] = useState();
  const [erpCode, setErpCode] = useState();
  const [firmName, setFirmName] = useState();
  const [form] = Form.useForm();
  const [salesDropdown, setSalesDropdown] = useState([]);

  const [firmTypeValue, setFirmTypeValue] = useState();
  const [directiveName, setDirectiveName] = useState();
  const [email, setEmail] = useState();
  const [erpSalesCode, setErpSalesCode] = useState();
  const inputRef = useRef(null);
  const [kdvList, setKdvList] = useState([]);
  const [loading, setLoading] = useState();
  const [senarioList, setSenarioList] = useState([{ key: "EARSIVFATURA", value: "E-ARŞİV FATURA" }]);
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const { TextArea } = Input;
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const { skip, take } = tableDataQueryOptions;
  useEffect(() => {
    RequestHandler.get(`/Currency`, false
    ).then((res) => {
      const currencyDropdown = res.value;
      setcurrencyDropdown(currencyDropdown)
    });
    reloadList();
  }, []);
  const codeOnChange = (value) => {
    setEInvoiceCodeId(value);
  }
  const onChangeTaxValue = (e) => {
    setTaxOffice(e.target.value);
  };
  const onChangeVknValue = (e) => {
    setVkn(e.target.value);
  };
  const onChangeAddressValue = (e) => {
    setAddress(e.target.value);
  };
  const onChangeCityValue = (e) => {
    setCity(e.target.value);
  };
  const onChangeStateValue = (e) => {
    setState(e.target.value);
  };
  const onChanceDescription = (e) => {
    setDescription(e.target.value);
  };
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onSearchSales = (val) => {
    if (val.length >= 3) {
      axios
        .get(
          `${config.apiUrl}/Stock?$filter=contains(stockCode, '${val}') or contains(name, '${val}')`,
          config.headers
        )
        .then((res) => {
          setSalesDropdown(res.data.value);
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            history.push("/not-authorized-access");
          } else if (error.response.status === 406) {
            error.response.data.data.map((item) => {
              errorList.push(item);
            });
            errorListNotification("error");
          }
        });
    } else {
      setSalesDropdown([]);
    }
  };

  const setAmountChange = (value, key) => {
    setVisibleUpdate(true);
    kdvPercentValue[key] = parseFloat(value.replaceAll('.', '').replace(',', '.'));
    let kdvLinePercent = kdvList[key] == undefined ? 0.20 : kdvList[key];
    kdvPercentValue[key] = (kdvPercentValue[key] * (kdvLinePercent + 1)).toFixed(2);
    setKdvPercent([kdvPercentValue]);
    inputAmountList[key] = parseFloat(value.replaceAll('.', '').replace(',', '.'));
    setInputAmountList(inputAmountList);
    // setKdvPercentValue()
  }

  const setAmountVATChange = (value, key) => {
    setVisibleUpdate(true);
    inputAmountList[key] = parseFloat(value.replaceAll('.', '').replace(',', '.'));
    let kdvLinePercent = kdvList[key] == undefined ? 0.20 : kdvList[key];
    inputAmountList[key] = (inputAmountList[key] / (kdvLinePercent + 1)).toFixed(2);
    setInputAmountList([...inputAmountList]);
    kdvPercentValue[key] = parseFloat(value.replaceAll('.', '').replace(',', '.'));
    setKdvPercent(kdvLinePercent);
    // setKdvPercentValue()
  }

  const reloadList = () => {
    RequestHandler.get(
      `/EInvoiceCode?$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  }
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: "Hata",
        description: item,
        duration: 4,
      });
    });
  };
  function disabledDate(current) {
    return current && current > moment().endOf('day');
  }
  const onFocusUpdate = () => {
    axios
      .get(
        `${config.apiUrl}/Firm?$filter=contains(name, '___')`,
        config.headers
      )
      .then((res) => {
        const firmDropdown = res.data.value;
        setFirmDropdown(firmDropdown);
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          history.push("/not-authorized-access");
        } else if (error.response.status === 406) {
          error.response.data.data.map((item) => {
            errorList.push(item);
          });
          errorListNotification("error");
        }
      });
  }
  const handleFirmId = (value) => {
    setFirmId(value);
  };
  function onChange(value) {
    setFirmId(value);
    RequestHandler.get(`/Firm/GetById/${value}`, false
    ).then((response) => {
      setTaxOffice(response.taxOffice)
      setAddress(response.address)
      setCity(response.city)
      setState(response.state)
      setVkn(response.vkn)
      setFirmBranchNumber(response.firmBranchNumber)
      setFirmName(response.name)
      setFirmTypeValue(response.firmTypeValue)
      setDirectiveName(response.directiveName)
      setEmail(response.email)
      setErpSalesCode(response.erpSalesCode)
      setTcNo(response.tcNo)
      setGroupCode(response.groupCode)
      response.phone == null || response.phone == undefined || response.phone == "" ? setPhone() : setPhone("+90" + response.phone)
      response.mobilePhone == null || response.mobilePhone == undefined || response.mobilePhone == "" ? setMobilPhone() : setMobilPhone("+90" + response.mobilePhone)
      setFax(response.fax)
      setFirmClassId(response.firmClassId)
      setErpCode(response.erpCode)
      let taxOffice = response.taxOffice?.trim();
      let vkn = response.vkn?.trim();
      let address = response.address?.trim();
      let city = response.city?.trim();
      let state = response.state?.trim();
      let name = response.name?.trim();
      if (vkn == null || vkn == undefined || vkn == "" ||
        address == null || address == undefined || address == "" ||
        taxOffice == null || taxOffice == undefined || taxOffice == "" ||
        city == null || city == undefined || city == "" ||
        state == null || state == undefined || state == "" ||
        name == undefined || name == "" || name == null) {
        setUpdateButtonVisible(true);
        Modal.error({
          title: 'Seçilen firmanın bilgileri eksik!',
          content: 'Eksik bilgileri girmediğiniz takdirde e-fatura işleminizi tamamlayamayacaksınız.',
          okText: "Düzenle",
          onOk: (() => { setEInvoiceCodeVisible(true) })
        });
      } else {
        setUpdateButtonVisible(false);
      }
      if (vkn != null && vkn != undefined && vkn != "") {
        RequestHandler.get(`/EArchive/CheckUser/${response.vkn}/false`, false
        ).then((resCheckUser) => {
          if (!resCheckUser.success) {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        });
      }

    });
  }
  function sendEArchive() {
    setSendEArchiveLoading(true)

    if (productList.length == 0 ||
      firmId == "" ||
      senario == "" ||
      dateChange == "" ||
      dateChange == null ||
      type == "" ||
      currencyChange == ""
    ) {
      errorSendEArchive("Zorunlu alanları lütfen doldurun.");
      return;
    }

    RequestHandler.post(`/EArchive/AddEArchive`,
      {
        EInvoiceItems: productList,
        FirmId: firmId,
        Senario: senario,
        Description: description,
        Date: dateChange,
        Type: type,
        CurrencyCode: currencyChange,
        EArchiveType: eArchiveType,
        TotalTaxAmount: taxPercent, //toplam vergi
        TotalAmount: totalWithTax, //vergili toplam tutar
        TotalAmountWithoutTax: totalAmount //vergisiz toplam tutar
      }, true
    ).then((response) => {
      if (!response.success) {
        errorSendEArchive(response.message)
        setSendEArchiveLoading(false)
      }
      setTimeout(() => {
        window.location.href = "/EArchiveList";
      }, 2000);
    });
  }
  function senarioChange(value) {
    setSenario(value)
  }
  function typeChange(value) {
    setType(value)
  }
  function typeEArchiveChange(value) {
    setEArchiveType(value)
  }
  function onCurrencyChange(value) {
    setCurrencyChange(value)
  }
  function onDateChange(value) {
    setDateChange(value)
  }

  function kdvChange(text, key) {
    setVisibleUpdate(true);
    setKdvPercent(text)
    kdvList[key] = parseFloat(text);
    setKdvList(kdvList);
    if (kdvPercentValue[key] !== undefined) {
      kdvPercentValue[key] = ((inputAmountList[key] * (kdvList[key] + 1))).toFixed(2);
    }

    setKdvPercent([kdvPercentValue]);
  }

  function onBlur() { }

  const onSearch = (val) => {
    if (val.length >= 3) {
      axios
        .get(
          `${config.apiUrl}/Firm?isFilter=true&$filter=contains(name, '${val}')`,
          config.headers
        )
        .then((res) => {
          setFirmDropdown(res.data.value);
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            history.push("/not-authorized-access");
          } else if (error.response.status === 406) {
            error.response.data.data.map((item) => {
              errorList.push(item);
            });
            errorListNotification("error");
          }
        });
    } else {
      setFirmDropdown([]);
    }
  };
  const onFinish = (values) => {
    var totalAmount = 0;
    var taxPercent = 0;
    var totalWithTax = 0;
    var invoiceItemList = [];
    values.users.map((item, index) => {
      let amount = inputAmountList[index];
      var model = {};
      if (item.kdv == undefined) {
        item.kdv = "0.20";
      }
      totalAmount += parseFloat(amount) * item.count;
      taxPercent += parseFloat(
        (parseFloat(amount) * item.count * parseFloat(item.kdv)).toFixed(2)
      );
      totalWithTax += parseFloat(
        (
          parseFloat(parseFloat(amount) * item.count) *
          (parseFloat(item.kdv) + 1).toFixed(2)
        ).toFixed(2)
      );
      model.KdvPercent = parseFloat(item.kdv);
      model.ProductCount = parseFloat(item.count);
      model.Amount = parseFloat(amount);
      model.SalesCode = item.salesCode;
      model.ProductName = item.productName;
      model.Description = item.description;
      invoiceItemList.push(model);
    });
    setTaxPercent(taxPercent.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));
    setTotalWithTax(totalWithTax.toFixed(2));
    setProductList(invoiceItemList);
  };
  const handleChange = (value) => {
  };
  const onFinishFailedUpdate = (errorInfo) => {
    setLoading(false);
  };
  const onFinishUpdate = (values) => {
    var taxOffice = values.TaxOffice?.trim() === "" ? null : values.TaxOffice?.trim();
    var address = values.Address?.trim() === "" ? null : values.Address?.trim();
    var city = values.City?.trim() === "" ? null : values.City?.trim();
    var state = values.State?.trim() === "" ? null : values.State?.trim();
    if (taxOffice === null || address === null ||
      city === null || state === null ||
      taxOffice === undefined || address === undefined ||
      city === undefined || state === undefined) {
      errorSendEArchive("Bilgiler boş bırakılamaz.");
      setLoading(false);
    } else {
      RequestHandler.get(`/EArchive/CheckUser/${values.Vkn}/false`, false
      ).then((resCheckUser) => {
        if (resCheckUser.success) {
          RequestHandler.put(
            "/Firm",
            {
              Id: firmId,
              TaxOffice: values.TaxOffice,
              Vkn: values.Vkn,
              Address: values.Address,
              City: values.City,
              State: values.State,
              Name: firmName,
              FirmBranchNumber: firmBranchNumber,
              firmTypeValue: firmTypeValue,
              directiveName: directiveName,
              email: email,
              erpSalesCode: erpSalesCode,
              tcNo: tcNo,
              groupCode: groupCode,
              phone: phone,
              mobilePhone: mobilPhone,
              fax: fax,
              firmClassId: firmClassId,
              erpCode: erpCode
            },
            true
          ).then((res) => {
            if (res.success) {
              setEInvoiceCodeVisible(false);
              setLoading(false);
              setUpdateButtonVisible(false);
            } else {
              setLoading(false);
              // setTimeout(() => {
              //     setEInvoiceCodeVisible(false);

              //     window.location.reload();
              //   }, 1500);
            }
          });
        } else {
          setAddress("");
          setCity("");
          setState("");
          setTaxOffice("");
          setVkn("");
          setLoading(false)
        }
      });

    }
  };
  const totalDataSource = [
    {
      key: '1',
      name: 'Mal/Hizmet Toplam Tutarı:',
      money: parseFloat(totalAmount),
    },
    {
      key: '2',
      name: 'Hesaplanan KDV:',
      money: parseFloat(taxPercent),
    },
    {
      key: '3',
      name: 'Vergiler Dahil Toplam Tutar:',
      money: parseFloat(totalWithTax),
    },
    {
      key: '4',
      name: 'Ödenecek Tutar:',
      money: parseFloat(totalWithTax),
    },
  ];

  const totalColumns = [
    {
      title: '',
      dataIndex: 'name',
      align: 'right',
      key: 'name',
    },
    {
      title: '',
      dataIndex: 'money',
      key: 'money',
      render: ColumnHelper.renderDecimal,
    }
  ];
  const deleteEInvoiceCode = () => {
    setEInvoiceCodeVisible(true);
    RequestHandler.get(
      `/EInvoiceCode?$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
    RequestHandler.get(`/EInvoiceCode`, false
    ).then((res) => {
      setEInvoiceList(res)
    });
  }
  const addItem = (e) => {
    e.preventDefault();
    RequestHandler.post(`/EInvoiceCode`,
      {
        Code: name,
      }, true
    ).then((response) => {
      if (response.success) {
        reloadList();
      }
    });
  };

  const onNameChange = (event) => {
    setName(event.target.value);
  };
  const errorSendEArchive = (value) => {
    Modal.error({
      title: value,
      content: '',
      okText: "Tamam",
      onOk: (() => { })

    });
    setSendEArchiveLoading(false);
  };
  const errorCheckUser = (value) => {
    Modal.error({
      title: value,
      content: 'İşlem yapamazsınız.',
      okText: "Tamam",
      onOk: (() => { window.location.reload() })

    });
  };
  return (
    <>
      <Col span={24}>
        <p style={{ fontSize: "120%" }}>
          <BarsOutlined /> E-ARŞİV
        </p>
      </Col>

      <Row>
        {/* MÜŞTERİ BİLGİLERİ */}
        <Col span={3}></Col>
        <Col span={18}>
          <Card
            title={<strong>MÜŞTERİ BİLGİLERİ</strong>}
            extra={updateButtonVisible ?
              <Tooltip placement="topLeft" title={"Eksik bilgileri buraya tıklayarak tamamlayabilirsiniz."}><a onClick={() => { setEInvoiceCodeVisible(true) }}><FormOutlined style={{ color: 'red', fontSize: 20 }} /></a></Tooltip>
              : ""}
            style={{
              width: '100%',
            }}
          >
            <Row>
              <Col span={12}>
                <Select
                  showSearch
                  placeholder="Firma seçimi için az 3 harf giriniz.."
                  optionFilterProp="children"
                  onChange={onChange}
                  onFocus={onFocusUpdate}
                  value={firmId === "" ? undefined : firmId}
                  style={{ width: '100%' }}
                  onBlur={onBlur}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {firmDropdown.map((item) => (
                    <Option value={item.id} key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Col>
              <Col span={12} style={{ marginBottom: 10, marginTop: 10 }}><strong>Vergi Dairesi</strong> : {taxOffice}

              </Col>
            </Row>
            <Row>
              <Col span={12} style={{ marginBottom: 10, marginTop: 10 }}>

                <strong>Adres</strong> : {address}
              </Col>
              <Col span={12} style={{ marginTop: 10 }}>
                <strong>Vergi No</strong> : {vkn}
              </Col>
            </Row>
            <Row>
              <Col span={12} style={{ marginBottom: 10, marginTop: 10 }}>
                <strong>İl</strong> : {city}
              </Col>
              <Col span={12} style={{ marginBottom: 10, marginTop: 10 }}>
                <strong>İlçe</strong> : {state}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={3}></Col>

        {/* FATURA BİLGİLERİ */}
        <Col span={3} ></Col>
        <Col span={18} style={{ marginTop: 30 }}>
          <Card
            title={<strong>FATURA BİLGİLERİ</strong>}
            extra={""}
            style={{
              width: '100%',
            }}
          >
            <Col span={24}>
              <Row >
                <Col span={12} style={{ marginBottom: 10, marginTop: 10 }}><strong>Senaryo</strong> :
                  <Select
                    showSearch
                    placeholder="Senaryo seçiniz"
                    optionFilterProp="children"
                    onChange={senarioChange}
                    defaultValue={"EARSIVFATURA"}
                    style={{ width: '100%' }}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {senarioList.map((item) => (
                      <Option value={item.ley} key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Col>
                <Col span={12} style={{ marginTop: 10 }}><strong>Tip</strong> :
                  <Select
                    showSearch
                    placeholder="Tip seçiniz"
                    optionFilterProp="children"
                    onChange={typeChange}
                    defaultValue={"SATIS"}
                    style={{ width: '100%' }}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    <Option value={"SATIS"} key={1}>SATIŞ</Option>
                  </Select>
                </Col>
                <Col span={12}><strong>Tarih</strong> :
                  <DatePicker defaultValue={moment(moment(), "DD-MM-YYYY")} format={"DD-MM-YYYY"} locale={locale} onChange={onDateChange} disabledDate={disabledDate} placeholder="Tarih seçiniz" style={{ width: "100%" }} />
                </Col>
                <Col span={12}><strong>Para Birimi</strong> :
                  <Select
                    showSearch
                    placeholder="Para birimini seçiniz"
                    optionFilterProp="children"
                    style={{ width: '100%' }}
                    onChange={onCurrencyChange}
                    defaultValue={"TRY"}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    <Option key={"TRY"}>{"TRY (₺)"}</Option>
                  </Select>
                </Col>
                <Col span={12} style={{ marginTop: 10 }}><strong>E-Arşiv Tipi</strong> :
                  <Select
                    showSearch
                    placeholder="E-Arşiv Tipi Seçiniz"
                    optionFilterProp="children"
                    defaultValue={1}
                    onChange={typeEArchiveChange}
                    style={{ width: '100%' }}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    <Option value={1} key={1}>NORMAL</Option>
                    {/* <Option value={0} key={0}>INTERNET</Option> */}
                  </Select>
                </Col>

              </Row>
            </Col>
          </Card>
        </Col>
        <Col span={3}></Col>

        {/* SATIR BİLGİLERİ */}
        <Col span={3} ></Col>
        <Col span={18} style={{ marginTop: 30 }}>
          <Card
            title={<strong>SATIR BİLGİLERİ</strong>}
            extra={""}
            style={{
              width: "100%",
            }}
          >
            <Col span={24}>
              <Form
                name="dynamic_form_nest_item"
                onFinish={onFinish}
                autoComplete="off"
                form={form}

              >
                <Form.List name="users" >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (

                        <Space
                          key={key}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 8,
                          }}
                        >
                          <Form.Item {...restField} name={[name, "number"]}>
                            <Input
                              placeholder={key + 1}
                              disabled
                              defaultValue={key + 1}
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "salesCode"]}
                            style={{ width: 270 }}
                          >
                            <Select
                              showSearch
                              allowClear
                              placeholder="Stok Kodu seçimi (3 harf giriniz)"
                              optionFilterProp="children"
                              onChange={(value) => {
                                const users = form.getFieldValue("users");
                                if (value != undefined) {
                                  const selectedItem = JSON.parse(value);
                                  users[name] = {
                                    ...users[name],
                                    productName: selectedItem.name,
                                    salesCode: selectedItem.stockCode
                                  };
                                  inputStockCountList[key] = selectedItem.count
                                  setInputStockCountList([...inputStockCountList]);
                                }
                                else {
                                  users[name] = {
                                    ...users[name],
                                    productName: undefined,
                                    salesCode: undefined
                                  };
                                  setInputStockCountList((prev) => ({
                                    ...prev,
                                    [key]: undefined
                                  }));
                                }
                                form.setFieldsValue({ users });
                                setVisibleUpdate(true);
                              }}
                              style={{ width: "100%" }}
                              onSearch={onSearchSales}
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLocaleLowerCase("tr-TR")
                                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                              }
                            >
                              {salesDropdown.map((item) => (
                                <Option value={JSON.stringify(item)} key={item.id}>
                                  {item.stockCode}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "productName"]}
                            rules={[
                              {
                                required: true,
                                message: "Ürün adı boş bırakılamaz",
                              },
                            ]}
                            style={{ width: 270 }}
                          >
                            <Select
                              showSearch
                              allowClear
                              placeholder="Ürün Adı seçimi (3 harf giriniz)"
                              optionFilterProp="children"
                              onChange={(value) => {
                                const users = form.getFieldValue("users");
                                if (value != undefined) {
                                  const selectedItem = JSON.parse(value);
                                  users[name] = {
                                    ...users[name],
                                    productName: selectedItem.name,
                                    salesCode: selectedItem.stockCode
                                  };
                                  inputStockCountList[key] = selectedItem.count
                                  setInputStockCountList([...inputStockCountList]);
                                } else {
                                  users[name] = {
                                    ...users[name],
                                    productName: undefined,
                                    salesCode: undefined
                                  };
                                  setInputStockCountList((prev) => ({
                                    ...prev,
                                    [key]: undefined
                                  }));
                                }
                                form.setFieldsValue({ users });
                                setVisibleUpdate(true);
                              }}
                              style={{ width: "100%" }}
                              onSearch={onSearchSales}
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLocaleLowerCase("tr-TR")
                                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                              }
                            >
                              {salesDropdown.map((item) => (
                                <Option value={JSON.stringify(item)} key={item.id}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "description"]}
                          >
                            <Input
                              placeholder="Açıklama"
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "count"]}
                            validateStatus={inputStockCountList[key] != undefined ? "error" : ""}
                            help={inputStockCountList[key] != undefined ? "Stok Miktarı : " + inputStockCountList[key] : ""}
                          >
                            <Input
                              placeholder="Adet"
                              type="number"
                              style={{ marginTop: 20 }}
                              min={1}
                              onChange={() => {
                                setVisibleUpdate(true);
                              }}
                            />
                          </Form.Item>
                          <Form.Item>
                            <CurrencyInput
                              placeholder="Kdv Hariç Tutar"
                              style={{ width: "100%" }}
                              onChange={(text) => setAmountChange(text, key)}
                              className="ant-input"
                              decimalSeparator=","
                              thousandSeparator="."
                              value={
                                inputAmountList[key] !== undefined
                                  ? parseFloat(
                                    inputAmountList[key]
                                  )?.toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : null}
                            />
                          </Form.Item>
                          <Form.Item>
                            <CurrencyInput
                              placeholder="Kdv Dahil Tutar"
                              style={{ width: "100%" }}
                              onChange={(text) => setAmountVATChange(text, key)}
                              className="ant-input"
                              decimalSeparator=","
                              thousandSeparator="."
                              value={
                                kdvPercentValue[key] !== undefined
                                  ? parseFloat(kdvPercentValue[key])?.toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : null
                              }
                            />
                          </Form.Item>
                          <Form.Item {...restField} name={[name, "kdv"]}>
                            <Select
                              defaultValue="0.20"
                              style={{ width: 120 }}
                              onChange={(text) => {
                                kdvChange(text, key);
                              }}
                            >
                              <Option value="0.01">%1</Option>
                              <Option value="0.10">%10</Option>
                              <Option value="0.20">%20</Option>
                            </Select>
                          </Form.Item>


                          {/* <Form.Item
                                                  {...restField}
                                                  name={[name, 'kdvAmount']}
                                                  >
                                                  <Input placeholder="Kdv tutarı" />
                                                  </Form.Item>
      
                                                  <Form.Item
                                                  {...restField}
                                                  name={[name, 'totalAmount']}
                                                  >
                                                  <Input placeholder="Toplam tutar" />
                                                  </Form.Item> */}
                          <MinusCircleOutlined onClick={() => { remove(name); setVisibleUpdate(true); }} />
                        </Space>
                      ))}
                      <Form.Item style={{ textAlign: "center" }}>
                        <Button
                          style={{ width: "25%" }}
                          type="dashed"
                          onClick={() => { add(); setVisibleUpdate(true); }}
                          block
                          icon={<PlusOutlined />}
                        >
                          Satır Ekle
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                <Form.Item>
                  <Button
                    style={{ float: "right" }}
                    onClick={() => {
                      setVisibleUpdate(false);
                    }}
                    type="primary"
                    htmlType="submit"
                  >
                    Satırları Kayıt Et
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Card>
        </Col>
        <Col span={3}></Col>


        {/* TOPLAM BİLGİLERİ */}
        <Col span={3} ></Col>
        <Col span={18} style={{ marginTop: 30 }}>
          <Card
            title={<strong>TOPLAM BİLGİLERİ</strong>}
            extra={""}
            style={{
              width: '100%',
            }}
          >
            <Col span={24}>
              <Row >
                <Col span={12}>
                  <TextArea rows={4} placeholder={"Fatura açıklaması giriniz."} value={description} onChange={onChanceDescription}></TextArea>
                </Col>
                <Col span={12}>
                  <Table style={{ width: '100%' }} showHeader={false} dataSource={totalDataSource} columns={totalColumns} pagination={false} />

                </Col>
                {/* <Col span={15} style={{marginBottom:10,marginTop:10}}></Col>
                           <Col span={5} style={{marginBottom:10,marginTop:10}}><strong>Mal/Hizmet Toplam Tutarı:</strong></Col>
                            <Col span={4} style={{marginBottom:10,marginTop:10}}> {totalAmount} TRY
                            </Col>

                            <Col span={15} style={{marginBottom:10,marginTop:10}}></Col>
                           <Col span={5} style={{marginBottom:10,marginTop:10}}><strong>Hesaplanan KDV:</strong></Col>
                            <Col span={4} style={{marginTop:10}}> {taxPercent} TRY</Col>

                            <Col span={15} style={{marginBottom:10,marginTop:10}}></Col>
                           <Col span={5} style={{marginBottom:10,marginTop:10}}><strong>Vergiler Dahil Toplam Tutar:</strong></Col>
                            <Col span={4} style={{marginTop:10}}> {totalWithTax} TRY</Col>

                            <Col span={15} style={{marginBottom:10,marginTop:10}}></Col>
                           <Col span={5} style={{marginBottom:10,marginTop:10}}><strong>Ödenecek Tutar:</strong></Col>
                            <Col span={4} style={{marginTop:10}}> {totalWithTax} TRY</Col> */}
              </Row>
            </Col>
          </Card>
        </Col>
        <Col span={3}></Col>

        {/* E FATURA OLUŞTUR */}
        <Col span={3} ></Col>
        <Col span={18}>
          {
            updateButtonVisible ?
              <Tooltip placement="topLeft" title={"Eksik firma bilgilerini tamamlamanız gerekmektedir."}><Button style={{ float: 'right', marginTop: 30, marginBottom: 30 }} disabled type="primary" loading={sendEArchiveLoading} onClick={() => { sendEArchive() }}>
                E-Arşiv Oluştur
              </Button></Tooltip>
              :
              (
                visibleUpdate ?
                  <Tooltip placement="topLeft" title={"Satır bilgilerini kayıt etmeniz gerekmektedir."}>
                    <Button style={{ float: 'right', marginTop: 30, marginBottom: 30 }} disabled={visibleUpdate} loading={sendEArchiveLoading} type="primary" onClick={() => { sendEArchive() }}>
                      E-Arşiv Oluştur
                    </Button>
                  </Tooltip>
                  :
                  <Button style={{ float: 'right', marginTop: 30, marginBottom: 30 }} disabled={visibleUpdate} loading={sendEArchiveLoading} type="primary" onClick={() => { sendEArchive() }}>
                    E-Arşiv Oluştur
                  </Button>
              )

          }
        </Col>
        <Col span={3} ></Col>
      </Row>
      <Modal
        id="deleteCodes"
        centered
        visible={eInvoiceCodeVisible}
        title="Düzenle"
        onCancel={() => setEInvoiceCodeVisible(false)}
        footer={null}
      >
        <Form
          {...layout}
          name="basic"

          initialValues={{
            remember: true,
          }}
          onFinish={onFinishUpdate}
          onFinishFailed={onFinishFailedUpdate}
          fields={[
            { name: "TaxOffice", value: taxOffice },
            { name: "Vkn", value: vkn },
            { name: "Address", value: address },
            { name: "City", value: city },
            { name: "State", value: state },
          ]}
        >
          <Row>
            <Col span={24}>

              <Form.Item label="Vergi Dairesi" name="TaxOffice">
                <Input onChange={onChangeTaxValue} />
              </Form.Item>

              <Form.Item
                label="Vergi Numarası"
                name="Vkn"
                rules={[
                  {
                    min: 10,
                    message: "Vergi Numarası 10 Karakter Olmalıdır.",
                  },
                ]}
              >
                <Input
                  onChange={onChangeVknValue}
                  type="number"
                  onKeyDown={(evt) => {
                    if (evt.key === "+" || evt.key === "e") {
                      evt.preventDefault();
                    }
                  }}
                  maxLength="10"
                  onInput={maxLengthCheck}
                />
              </Form.Item>

              <Form.Item label="Adres" name="Address">
                <TextArea onChange={onChangeAddressValue} rows={4} />
              </Form.Item>
              <Form.Item label="İl" name="City">
                <Input onChange={onChangeCityValue} />
              </Form.Item>
              <Form.Item label="İlçe" name="State">
                <Input onChange={onChangeStateValue} />
              </Form.Item>
            </Col>


          </Row>
          <Row style={{ justifyContent: 'right' }}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default CreateEArchive
